import { render, staticRenderFns } from "./item-picker-expand-column.vue?vue&type=template&id=4e4d98b6"
import script from "./item-picker-expand-column.vue?vue&type=script&lang=js"
export * from "./item-picker-expand-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e4d98b6')) {
      api.createRecord('4e4d98b6', component.options)
    } else {
      api.reload('4e4d98b6', component.options)
    }
    module.hot.accept("./item-picker-expand-column.vue?vue&type=template&id=4e4d98b6", function () {
      api.rerender('4e4d98b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/campaign-template/item-picker-expand-column.vue"
export default component.exports